export default "__VITE_ASSET__KIvC90Yv__"